
import './styles.css';
import InsaneTable from '../../component/insane-table';

//////////// REDUX | STORE | SERVICE /////////////
import { HttpRequest } from '../../service/HttpRequest';

function SettingsUser() {
    
    let plantList = [];

    let booleanOption = [
        { displayName: "TRUE", value: "true" },
        { displayName: "FALSE", value: "" }
    ]

    HttpRequest("/admin/pd/plant/get", {}).then(data => {
        // console.log("_plant" ,data);
        if (data.result === "OK") {
            for (let i = 0; i < data.plants.length; i++) {
                const _plant = data.plants[i];
                plantList.push({
                    displayName: _plant.plantid + " (" +_plant.plantname + ")",
                    value: _plant.plantid
                })
            }
        }
    });

    // console.log(plantList)

    const tableOption = {
        tableName: "User",
        className: "",
        search: [
            {
                reqName: "fqn",
                displayName: "FQN",
                element: "input",
                placeholder: "Enter FQN."
            },
            {
                reqName: "plantid",
                displayName: "Plant ID",
                element: "select",
                placeholder: "Enter Plant ID.",
                option: plantList
            }
        ],
        mapTable: [
            {
                displayName: "FQN",
                attName: ["fqn","name"],
                type: "merge",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "User ID",
                attName: "userid",
                type: "text",
                form: {
                    validate: false,
                    enable: false,
                    element: "input"
                }
            },
            {
                displayName: "Plant ID",
                attName: "plantid",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "select",
                    option: plantList
                }
            },
            {
                displayName: "PD Checksheet",
                attName: "pd_checksheet",
                type: "boolean",
                form: {
                    validate: true,
                    enable: true,
                    element: "select",
                    option: booleanOption
                }
            },
            {
                displayName: "PD Result",
                attName: "pd_result",
                type: "boolean",
                form: {
                    validate: true,
                    enable: true,
                    element: "select",
                    option: booleanOption
                }
            },
            {
                displayName: "Setting User",
                attName: "st_user",
                type: "boolean",
                form: {
                    validate: true,
                    enable: true,
                    element: "select",
                    option: booleanOption
                }
            },
            {
                displayName: "Setting Equipment",
                attName: "st_equipment",
                type: "boolean",
                form: {
                    validate: true,
                    enable: true,
                    element: "select",
                    option: booleanOption
                }
            },
            {
                displayName: "PD App",
                attName: "pd_app",
                type: "boolean",
                form: {
                    validate: true,
                    enable: true,
                    element: "select",
                    option: booleanOption
                }
            },
            {
                displayName: "MT App",
                attName: "mt_app",
                type: "boolean",
                form: {
                    validate: true,
                    enable: true,
                    element: "select",
                    option: booleanOption
                }
            },
            {
                displayName: "MT Workorder",
                attName: "mt_workorder",
                type: "boolean",
                form: {
                    validate: true,
                    enable: true,
                    element: "select",
                    option: booleanOption
                }
            },
            {
                displayName: "MT Gas",
                attName: "mt_gas",
                type: "boolean",
                form: {
                    validate: true,
                    enable: true,
                    element: "select",
                    option: booleanOption
                }
            }
        ],
        api: {
            view: {
                enable: true,
                url: "/admin/user/get",
                dataReq: {
                    "index": 0,
                    "count": 10
                }
            },
            insert: {
                enable: true,
                url: "/admin/user/update",
                dataReq: {
                    "fqn": "",
                    "plantid": "",
                    "pd_checksheet": "",
                    "pd_result": "",
                    "st_user": "",
                    "st_equipment": "",
                    "pd_app": "",
                    "mt_app": "",
                    "mt_workorder": "",
                    "mt_gas": ""
                }
            },
            update: {
                enable: true,
                url: "/admin/user/update",
                dataReq: {
                    "userid": "",
                    "fqn": "",
                    "plantid": "",
                    "pd_checksheet": "",
                    "pd_result": "",
                    "st_user": "",
                    "st_equipment": "",
                    "pd_app": "",
                    "mt_app": "",
                    "mt_workorder": "",
                    "mt_gas": ""
                }
            },
            delete: {
                enable: true,
                url: "/admin/user/delete",
                dataReq: {
                    "userid": ""
                }
            }
        },
        action: [
            {
                name: "Edit",
                mode: "modal-form", /// page, modal, form
                option: {
                    type: "update"
                }
            }
        ]
    }

    return (
        <div className='content'>

            <div className='content-page'>
                <div className='head-content-page'>User Management.</div>
                <InsaneTable option={tableOption}></InsaneTable>
            </div>

        </div >
    );
}

export default SettingsUser;